import React from 'react'
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../form/InputField';

export interface CoupounFormData {
  code: string;
  discountPercentage: number;
  maxUsage: number;
  startDate: string | null;
  expiryDate: string | null;
}

interface Props {
  register: UseFormRegister<CoupounFormData>;
  errors: FieldErrors<CoupounFormData>;
  watch: UseFormWatch<CoupounFormData>;
}

function CoupounForm({ register, errors, watch }: Props) {
  const { t } = useTranslation();
  const start = watch("startDate");

  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        {/* Code */}
        <InputField
          placeholder=""
          label={t("code")}
          register={register("code", { required: t("required_field") as string })}
          type="text"
          error={errors.code}
        />

        {/* Discount Percentage */}
        <InputField
          placeholder=""
          label={t("discountPercentage")}
          register={register("discountPercentage", { 
            required: t("required_field") as string, 
            valueAsNumber: true,
            min: { value: 1, message: t("discount_min") },
            max: { value: 100, message: t("discount_max") }
          })}
          type="number"
          error={errors.discountPercentage}
        />
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {/* Max Usage */}
        <InputField
          placeholder=""
          label={t("maxUsage")}
          register={register("maxUsage", { 
            required: t("required_field") as string, 
            valueAsNumber: true,
            min: { value: 1, message: t("maxUsage_min") }
          })}
          type="number"
          error={errors.maxUsage}
        />

        {/* Start Date (optional) */}
        <InputField
          placeholder=""
          label={t("startDate")}
          register={register("startDate")}
          type="datetime-local"
          error={errors.startDate}
          defaultValue={""}
        />
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {/* Expiry Date (optional, must be after startDate if provided) */}
        <InputField
          placeholder=""
          label={t("endDate")}
          register={register("expiryDate", {
            validate: (value) =>
              !value || !start || new Date(value) > new Date(start) || t("expiryDate_must_be_after_startDate")
          })}
          type="datetime-local"
          error={errors.expiryDate}
        />
      </div>
    </>
  );
}

export default CoupounForm;
